import React, {
  useState,
} from "react";

import {
  User,
  Mail,
  Phone,
  FileText,
  Send,
  X,
  CheckCircle2,
  AlertTriangle,
  ShieldCheck,
} from "lucide-react";

import emailjs from "@emailjs/browser";

import "./subscriberform.css";

import { uploadToS3 }
from "../utils/s3Uploader";

const SubscriberFormModal = ({
  onClose,
}) => {

  const [uploadedFiles,
    setUploadedFiles] =
      useState([]);

  const [sending,
    setSending] =
      useState(false);

  const [status,
    setStatus] =
      useState("");

  const [formData,
    setFormData] =
      useState({
        subscriber_name: "",
        subscriber_email: "",
        subscriber_phone: "",
      });

  const handleFileChange =
    (e) => {

    const files =
      Array.from(e.target.files);

    setUploadedFiles(files);
  };

  const handleSubmit =
    async (e) => {

    e.preventDefault();

    try {

      setSending(true);

      const fileLinks = [];

      for (let file of uploadedFiles) {

        const url =
          await uploadToS3(file);

        fileLinks.push(
`📎 ${file.name}: ${url}`
);
      }

      await emailjs.send(

        "service_r1kg6tc",

        "template_3korvfq",

        {
          subscriber_name:
            formData.subscriber_name,

          subscriber_email:
            formData.subscriber_email,

          subscriber_phone:
            formData.subscriber_phone,

          file_links:
            fileLinks.join("\n"),
        },

        "0fmWeTGurdz-26yqR"
      );

      setSending(false);

      setStatus("success");

      setUploadedFiles([]);

      setFormData({
        subscriber_name: "",
        subscriber_email: "",
        subscriber_phone: "",
      });

    } catch (err) {

      console.error(err);

      setSending(false);

      setStatus("failure");
    }

    setTimeout(() => {

      setStatus("");

      if (
        status === "success"
      ) {
        onClose();
      }

    }, 10000);
  };

  return (

    <div className="modern-subscriber-overlay">

      <div className="modern-subscriber-modal">

        {/* CLOSE */}

        <button
          className="modern-subscriber-close"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        {/* HEADER */}

        <div className="modern-subscriber-header">

          <div className="modern-subscriber-icon">
            <ShieldCheck size={34} />
          </div>

          <div>

            <h2>
              MMG+ Subscriber Sign-Up
            </h2>

            <p>
              Become a registered
              MMG+ subscriber today.
            </p>

          </div>

        </div>

        {/* FORM */}

        <form
          onSubmit={handleSubmit}
          className="modern-subscriber-form"
        >

          <div className="modern-subscriber-grid">

            <div className="modern-subscriber-group">

              <label>
                Full Name
              </label>

              <div className="modern-subscriber-input">

                <User size={18} />

                <input
                  type="text"
                  placeholder="Enter full name"
                  value={
                    formData.subscriber_name
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      subscriber_name:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

            </div>

            <div className="modern-subscriber-group">

              <label>
                Contact Number
              </label>

              <div className="modern-subscriber-input">

                <Phone size={18} />

                <input
                  type="tel"
                  placeholder="Enter contact number"
                  value={
                    formData.subscriber_phone
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      subscriber_phone:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

            </div>

          </div>

          <div className="modern-subscriber-group">

            <label>
              Email Address
            </label>

            <div className="modern-subscriber-input">

              <Mail size={18} />

              <input
                type="email"
                placeholder="Enter email"
                value={
                  formData.subscriber_email
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    subscriber_email:
                      e.target.value,
                  })
                }
                required
              />

            </div>

          </div>

          {/* UPLOAD */}

          <div className="modern-subscriber-group">

            <label>
              Upload Documents
            </label>

            <label className="modern-subscriber-upload">

              <FileText size={26} />

              <span>
                Upload ID or
                Driver’s Licence
              </span>

              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                onChange={
                  handleFileChange
                }
              />

            </label>

          </div>

          {/* FILES */}

          {uploadedFiles.length >
            0 && (

            <div className="modern-subscriber-files">

              {uploadedFiles.map(
                (file, index) => (

                <div
                  className="modern-subscriber-file"
                  key={index}
                >

                  <FileText size={16} />

                  {file.name}

                </div>
              ))}

            </div>
          )}

          {/* BUTTONS */}

          <div className="modern-subscriber-actions">

            <button
              type="submit"
              className="modern-subscriber-submit"
            >

              {sending ? (
                <>
                  <Send size={18} />
                  Sending...
                </>
              ) : (
                <>
                  <Send size={18} />
                  Submit Application
                </>
              )}

            </button>

            <button
              type="button"
              className="modern-subscriber-cancel"
              onClick={onClose}
            >
              Cancel
            </button>

          </div>

        </form>

        {/* STATUS */}

        {status && (

          <div
            className={`modern-subscriber-status ${
              status
            }`}
          >

            {status ===
            "success" ? (
              <>
                <CheckCircle2
                  size={72}
                />

                <h3>
                  Application Sent!
                </h3>

                <p>
                  Our team will
                  contact you shortly.
                </p>
              </>
            ) : (
              <>
                <AlertTriangle
                  size={72}
                />

                <h3>
                  Submission Failed
                </h3>

                <p>
                  Please try again later.
                </p>
              </>
            )}

          </div>
        )}

      </div>

    </div>
  );
};

export default SubscriberFormModal;